import { CheckoutStepComponentDef } from '@df/checkout/checkout-step.component.def';

export abstract class FastCheckoutStepComponentDef extends CheckoutStepComponentDef {}
